import * as React from 'react';
import {Component} from 'react';
import {autorun} from 'mobx'
import {observer} from "mobx-react"
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Layout, Menu, Breadcrumb } from 'antd';
import 'antd/dist/antd.css';
import '../index.css'

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;






autorun(() => {
    //console.log("CardNumber " + game.currentCardNumber + ", CardType " + game.currentCardType + " ,Score " + game.score);
    //console.log(game.decks);
})

@observer
export default class Verkauf extends React.Component {

    render()
    {
        return (
            <div className="selling_page">
                <iframe src="https://www.landwirt.com/gebrauchte/haendler,3661,Mehele-R-u-S-GmbH.html" style={{width: "100%", height: "100%", border : 0 }}>
                </iframe>
            </div>



        );

    }
}


